import { render, staticRenderFns } from "./PropertyExploitation.vue?vue&type=template&id=638dcb4d"
import script from "./PropertyExploitation.vue?vue&type=script&lang=js"
export * from "./PropertyExploitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports